import React from "react";

import "../../Styles/Home/Home.css";
function Home({
  bio,
  skills,
  profilePic,
  resume,
  first_name,
  last_name,
  setLoading,
  handleRobotText,
}) {
  const [skillsToShow, setSkillsToShow] = React.useState([]);

  const animate = (e) => {
    const picture = document.querySelector(".pictures");
    const logos = document.querySelectorAll(".logos");
    logos.forEach((logo) => {
      logo.style.transform = `translateX(${
        ((e.clientX * 80) / window.innerWidth / 1.5) % 100
      }%)
                              translateY(${
                                ((e.clientY * 80) / window.innerHeight / 1.5) %
                                100
                              }%)`;
      // picture.style.transform = `translateX(${
      //   ((e.clientX * 80) / window.innerWidth / 5) % 100
      // }%) translateY(${((e.clientY * 80) / window.innerHeight / 5) % 100}%)`;
    });
  };

  React.useEffect(() => {
    let temp = [];
    while (temp.length < 6) {
      temp.push(Math.floor(Math.random() * skills.length));
    }
    setSkillsToShow(skills.filter((skill, i) => temp.includes(i)));
  }, [skills]);

  React.useEffect(() => {
    window.addEventListener("mousemove", animate);
    return () => {
      window.removeEventListener("mousemove", animate);
    };
  }, [skillsToShow]);

  const handleONLoad = () => {
      setLoading(false);
  };
  return (
    <section className="home" id="home">
      <div className="homeContainer flexBox">
        <div className="details">
          <div className="title">
            <p>Full Stack Developer</p>
          </div>
          <h1>
            <span>Hi I'm</span>
            {first_name ? ` ${first_name} ${last_name}` : " Darshan Naik"}.
          </h1>
          <p>{bio}</p>
          <div
            className="call"
           
          >
            <a href="#contacts"  onMouseEnter={() =>
              handleRobotText("Do you want to chat with him...?")
            }>LET'S CHAT!</a>
            {/* <a
              href={resume}
              download={`${first_name} ${last_name}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
            </a> */}
          </div>
        </div>
        <div className="pictures flexBox">
          <img src={profilePic} alt="Me" onLoad={handleONLoad} onMouseEnter={()=>handleRobotText("He has some good photography skills...")}/>

          {skillsToShow.map((skill, i) => (
            <div key={i} className={`logos glass light flexBox logo${i + 1}`}>
              <img src={skill.image} alt="logo" />
            </div>
          ))}
          <div className="logos flexBox logo7"></div>
        </div>
      </div>
    </section>
  );
}

export default Home;
